import React from 'react'
import styles from './styles.module.css'

const TagRequired = ({ children }) => {
  return (
    <span className={`${styles.container} ${styles.required}`} data-testid="tag-required">
      {children}
    </span>
  )
}

export default TagRequired
